import { Flex, useTheme } from '@vitvio/design-system';

export function LayoutSidebar({ children }: { children?: React.ReactNode }) {
  const { getSpacing } = useTheme();
  return (
    <Flex flexDir={'column'} mx={getSpacing('3')} mt={getSpacing('5')} paddingLeft={getSpacing('2')}>
      {children}
    </Flex>
  );
}
